/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#setActiveSearchResult__anchor
 */
export default result => {
  window.documentViewer.setActiveSearchResult(result);
};
